// extracted by mini-css-extract-plugin
export default {"box":"UploadTile_box__tz2lL","dibba":"UploadTile_dibba__sFc+E"};